export default "__VITE_ASSET__0yGWP2mz__"